import { UniStorage } from './storage/UniStorage';
import { WebStorage } from './web-storage';

export class UniStorageFactory {
  private static webStorage: UniStorage;

  public static get UniStorage(): UniStorage {
    return UniStorageFactory.webStorage;
  }

  public static initWebStorage(backendUri: string) {
    UniStorageFactory.webStorage = new WebStorage(backendUri);
  }

  public static init(storage: UniStorage) {
    UniStorageFactory.webStorage = storage;
  }
}
